/* eslint-disable no-invalid-this */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
// CONSTANTS are all caps.
const NS = 'HorizontalGalleryBlock';
const CLS = 'horizontalGalleryBlock';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/horizontalGalleryBlock.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

export class HorizontalGalleryBlock {
	constructor($el) {
		// $el is the widget node return by the loadHorizontalGalleryBlock function
		this.$el = $($el);
	}

	init() {
		let $carousel = this.$el.find(`${WG}carousel`);
		let $wg = this.$el;
		let navActiveClass = 'is-active';

		$carousel.on('init', (slick) => {
			this.$el.find('.sliderNav-link').on('click', function() {
				let $this = $(this);
				let index = $this.attr('data-slide-index');

				$carousel.slick('slickGoTo', index);
				$this.siblings().removeClass(navActiveClass);
				$this.addClass(navActiveClass);

				// detach the line and put it before the active item
				let $sliderNavLine = $wg.find('.sliderNav-line').detach();
				$this.before($sliderNavLine);
			});
		}).slick({
			arrows: false,
			dots: false,
			appendDots: this.$el.find(`${WG}carouselDots`),
			draggable: true,
			slidesToShow: 1,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						dots: true,
					},
				},
			],
		}).on('afterChange', (event, slick, currentSlide) => {
			let $sliderNavLine = $wg.find('.sliderNav-line').detach();
			this.$el.find(`.sliderNav-link`).removeClass(navActiveClass);
			this.$el.find(`.sliderNav-link[data-slide-index=${currentSlide}]`).addClass(navActiveClass).before($sliderNavLine);
		});

		$wg.on('mouseenter', '.horizontalScrollItem', function() {
			if ($(this).find('a').length > 0) {
				$(this).addClass('hover');
			}
		}).on('mouseleave', '.horizontalScrollItem', function() {
			$(this).removeClass('hover');
		});
	}

	// Add more functions like on above here
}
